class DynamicModal extends HTMLElement {
  constructor() {

    super();
    this.sectionLoaded = false
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.dynamicContent = this.querySelector('#dynamic-content');
    this.injectScripts= this.getAttribute('injectScripts') ?? ''

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.summaryToggle.addEventListener('mouseover', this.onHover.bind(this));

    this.summaryToggle.setAttribute('role', 'button');

  }



  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  async onHover() {
    if(!this.sectionLoaded){
      this.sectionLoaded = true
      const scriptsToInject = this.injectScripts.split(',') ?? []
      await Promise.all([
        await fetch(window.location.origin + "?section_id=header-search-dynamic-content")
          .then(response => response.text())
          .then(html => {
            this.dynamicContent.style.width = "100%";
            this.dynamicContent.style.height = "100%";
            this.dynamicContent.style.margin = "auto";
            this.dynamicContent.style.display="flex"
            this.detailsContainer.style.position = 'block'
            this.dynamicContent.style.justifyContent = "center"; // Ce
            this.dynamicContent.innerHTML = html
            this.dynamicContent.children[0].style.width = "100%";


            const closeButton = this.querySelector('button[type="button"]#close-modal-button')
            if(closeButton){
              closeButton.addEventListener('click', this.close.bind(this));
            }

          })
          .catch(error => console.error("Error cargando sección dinámica:", error)),
        scriptsToInject.map(script => this.injectScript(script))
      ])

      this.sectionLoaded = true
    }

  }

  injectScript(src) {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        return resolve();
      }

      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.onload = () => {
        resolve();
      };
      script.onerror = () => reject(new Error(`Error injecting ${src}`));
      document.body.appendChild(script);
    });
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.removeEventListener('mouseover', this.onHover);
    document.body.classList.remove('overflow-hidden');
  }

}

customElements.define('dynamic-modal', DynamicModal);
